import { Constant } from "../../Constant";
import { combineReducers } from "redux";
import { isNotEmpty } from "../../Utils";

const currentStep = (state = "", action) => {
    let { type, payload } = action;
    switch (type) {
        case Constant.action.GET_FORM_TEMP.DONE:
            return payload.currentStep;
        default:
            return state;
    }
};

const fieldValues = (state = {}, action) => {
    let { type, payload } = action;
    let restFieldValues = payload;
    if (isNotEmpty(payload?.currentStep)) {
        const { currentStep, ...rest } = payload;
        restFieldValues = rest;
    }
    switch (type) {
        case Constant.action.GET_FORM_TEMP.DONE:
            return { ...restFieldValues };
        default:
            return state;
    }
};

const formLanguage = (state = "", action) => {
    const { type, payload } = action;
    switch (type) {
        case Constant.action.GET_FORM_TEMP_LANGUAGE:
            switch (payload.formLanguage) {
                case "Cht":
                    return "tc";
                case "Chs":
                    return "sc";
                case "Eng":
                    return "en";
                default:
                    return "";
            }
        default:
            return state;
    }
};

const formTemp = combineReducers({ currentStep, fieldValues, formLanguage });

export default formTemp;
